export default "__VITE_ASSET__1527a2c1__"